/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
  Typography,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { getAnteojo, getArreglo, iniciaProduccion } from "../../services/ProduccionService";
import { getCristalBlock } from "../../services/ArticuloService";
import { getCacheData } from "../../services/CacheService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import { isNumeric } from "../../utils/utils";
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

const initialIniciarAnteojoArregloData = {
  anteojoArreglo: "",
  bandeja: "",
  monturaNuevoCliente: "cliente",
  monturaNuevoClienteAgregadoBandeja: false,
  idArticuloArmAsol: "",
  clienteDejaSuAnteojo: false,
  oiTieneBlockCristal: true,
  oiIdBlockCristal: "",
  oiCodigoBlockCristal: "",
  oiDescripcionBlockCristal: "",
  odTieneBlockCristal: true,
  odIdBlockCristal: "",
  odCodigoBlockCristal: "",
  odDescripcionBlockCristal: "",
  observaciones: "",
  paseDeCristales: false,
  idAreaDestino: "",
};
//
// ###########################################################################
//
const IniciarAnteojoArregloDialog = ({
  anteojoArreglo,
  codigoAnteojoArreglo,
  idGcAnteojoArreglo,
  onIniciarAnteojoArreglo,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [iniciarAnteojoArregloData, setIniciarAnteojoArregloData] = useState(
    initialIniciarAnteojoArregloData
  );
  const [esAnteojo, setEsAnteojo] = useState(false);
  const [esArreglo, setEsArreglo] = useState(false);
  const [anteojo, setAnteojo] = useState({});
  const [anteojoTratamientoRows, setAnteojoTratamientoRows] = useState([]);
  const [arreglo, setArreglo] = useState({});
  const [arregloFornituraRows, setArregloFornituraRows] = useState([]);
  const [arregloServicioRows, setArregloServicioRows] = useState([]);
  const [arregloTratamientoRows, setArregloTratamientoRows] = useState([]);
  const [idGestionAtencion, setIdGestionAtencion] = useState("");
  const [agregarArmAsolNuevoDisabled, setAgregarArmAsolNuevoDisabled] = useState(false);
  const [quitarArmAsolNuevoDisabled, setQuitarArmAsolNuevoDisabled] = useState(true);
  const [agregarMonturaClienteDisabled, setAgregarMonturaClienteDisabled] = useState(false);
  const [quitarMonturaClienteDisabled, setQuitarMonturaClienteDisabled] = useState(true);
  const [agregarOiBlockCristalDisabled, setAgregarOiBlockCristalDisabled] = useState(false);
  const [quitarOiBlockCristalDisabled, setQuitarOiBlockCristalDisabled] = useState(true);
  const [agregarOdBlockCristalDisabled, setAgregarOdBlockCristalDisabled] = useState(false);
  const [quitarOdBlockCristalDisabled, setQuitarOdBlockCristalDisabled] = useState(true);
  const [areas, setAreas] = useState([]);
  const [valueACArea, setvalueACArea] = useState({
    id: "",
    descripcion: "",
  });
  const [inputvalueACArea, setInputvalueACArea] = useState("");

  const tableColumnsTratamiento = [
    {
      field: "ojo",
      headerName: "Ojo",
      align: "center",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_marca",
      headerName: "Marca",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tiempo_produccion",
      headerName: "Tiempo de Producción",
      type: "number",
      align: "center",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tiempo_produccion;
        _val = _val ? _val + " días" : "";
        return _val;
      },
    },
  ];

  const tableColumnsFornitura = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Servicio",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableColumnsServicio = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    getRowId: (row) =>
      row.id_gc_anteojo_tratamiento ??
      row.id_gc_arreglo_servicio ??
      row.id_gc_arreglo_tratamiento ??
      row.id_gc_arreglo_fornitura ??
      row.id_articulo ??
      row.id ??
      `${row.codigo_articulo ?? ''}-${row.descripcion_articulo ?? ''}-${row.cantidad ?? ''}`,
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadAnteojoArreglo = async () => {
      setIsDoingSomething(true);
      const response =
        anteojoArreglo == "anteojo"
          ? await getAnteojo(idGcAnteojoArreglo)
          : await getArreglo(idGcAnteojoArreglo);
      setIsDoingSomething(false);

      if (response.ok) {
        setIdGestionAtencion(
          anteojoArreglo === "anteojo"
            ? response.data.data.anteojo.id_gc
            : response.data.data.arreglo.id_gc
        );

        let _anteojoArregloObject = {};

        if (response.data.data.anteojo) {
          // si es un anteojo

          _anteojoArregloObject = response.data.data.anteojo;
          let _anteojoObject = response.data.data.anteojo;

          _anteojoObject = {
            ..._anteojoObject,
            cristalOI: _anteojoObject.codigo_articulo_cristal_oi
              ? _anteojoObject.codigo_articulo_cristal_oi +
              " - " +
              _anteojoObject.modelo_articulo_cristal_oi
              : "",
            cristalOD: _anteojoObject.codigo_articulo_cristal_od
              ? _anteojoObject.codigo_articulo_cristal_od +
              " - " +
              _anteojoObject.modelo_articulo_cristal_od
              : "",
            armazonAsol:
              _anteojoObject.codigo_articulo +
              " - " +
              _anteojoObject.descripcion_articulo +
              " - " +
              _anteojoObject.descripcion_ar_as_marca +
              " - " +
              _anteojoObject.modelo_articulo,
            clienteDejaSuAnteojoDetalle: _anteojoObject.cliente_deja_su_anteojo
              ? "CLIENTE DEJO SU ANTEOJO"
              : "",
            nombreApellidoCliente:
              _anteojoObject.nombre_cliente + " " + _anteojoObject.apellido_cliente,
            telefonosCliente:
              _anteojoObject.telefono_movil_cliente + " " + _anteojoObject.telefono_cliente,
            fechaNacimientoClienteEdad:
              _anteojoObject.fecha_nac_cliente + " - " + _anteojoObject.edad_cliente + " años",
            tipoDeAnteojo:
              _anteojoObject.tipo_anteojo === "monofocal-cerca"
                ? "Monofocal de cerca"
                : _anteojoObject.tipo_anteojo === "monofocal-lejos"
                  ? "Monofocal de lejos"
                  : _anteojoObject.tipo_anteojo === "monofocal-intermedia"
                    ? "Monofocal intermedia"
                    : _anteojoObject.tipo_anteojo === "bifocal"
                      ? "Bifocal"
                      : _anteojoObject.tipo_anteojo === "multifocal"
                        ? "Multifocal"
                        : _anteojoObject.tipo_anteojo === "ocupacional"
                          ? "Ocupacional"
                          : "",
          };

          setIniciarAnteojoArregloData({
            ...iniciarAnteojoArregloData,
            anteojoArreglo: "anteojo",
            monturaNuevoCliente: _anteojoObject.montura_nuevo_cliente,
            clienteDejaSuAnteojo: _anteojoObject.cliente_deja_su_anteojo,
            oiTieneBlockCristal: _anteojoObject.id_articulo_cristal_oi === null ? false : true,
            odTieneBlockCristal: _anteojoObject.id_articulo_cristal_od === null ? false : true,
          });
          setEsAnteojo(true);
          setEsArreglo(false);
          setAnteojo(_anteojoObject);
          setAnteojoTratamientoRows(response.data.data.anteojo.gc_anteojo_tratamiento_list);
        } else {
          // si es un arreglo

          _anteojoArregloObject = response.data.data.arreglo;
          let _arregloObject = response.data.data.arreglo;

          _arregloObject = {
            ..._arregloObject,
            armazonAsol:
              _arregloObject.codigo_articulo +
              " - " +
              _arregloObject.descripcion_articulo +
              " - " +
              _arregloObject.descripcion_ar_as_marca +
              " - " +
              _arregloObject.modelo_articulo,
            nombreApellidoCliente:
              _arregloObject.nombre_cliente + " " + _arregloObject.apellido_cliente,
            telefonosCliente:
              _arregloObject.telefono_movil_cliente + " " + _arregloObject.telefono_cliente,
            fechaNacimientoClienteEdad:
              _arregloObject.fecha_nac_cliente + " - " + _arregloObject.edad_cliente + " años",
          };

          setIniciarAnteojoArregloData({
            ...iniciarAnteojoArregloData,
            anteojoArreglo: "arreglo",
            monturaNuevoCliente: _arregloObject.montura_nuevo_cliente,
            clienteDejaSuAnteojo: true,
            paseDeCristales: _arregloObject.pase_de_cristales,
          });
          setEsAnteojo(false);
          setEsArreglo(true);
          setArreglo(_arregloObject);
          setArregloFornituraRows(response.data.data.arreglo.gc_arreglo_fornitura_list);
          setArregloServicioRows(response.data.data.arreglo.gc_arreglo_servicio_list);
          setArregloTratamientoRows(response.data.data.arreglo.gc_arreglo_tratamiento_list);
        }
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };

    loadAnteojoArreglo();
    loadAreas();
  }, []);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.actividad === "produccion" && !area.produccion_despacho);
      setAreas(_response);
    } else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
      return;
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setIniciarAnteojoArregloData({
      ...iniciarAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleBuscarBlockCristalOI = () => {
    if (iniciarAnteojoArregloData.oiCodigoBlockCristal === "") {
      return;
    }
    buscarBlockCristal("OI", iniciarAnteojoArregloData.oiCodigoBlockCristal);
  };
  //
  // ################################################################################
  //
  const handleBuscarBlockCristalOD = () => {
    if (iniciarAnteojoArregloData.odCodigoBlockCristal === "") {
      return;
    }
    buscarBlockCristal("OD", iniciarAnteojoArregloData.odCodigoBlockCristal);
  };
  //
  // ################################################################################
  //
  const buscarBlockCristal = async (parOjo, parCodigoBlockCristal) => {

    parCodigoBlockCristal = limpiaCodigo(parCodigoBlockCristal).toUpperCase()

    if (parOjo === "OI") {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        oiCodigoBlockCristal: parCodigoBlockCristal,
      });
    } else {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        odCodigoBlockCristal: parCodigoBlockCristal,
      });
    }

    let _params = {
      codigo: parCodigoBlockCristal,
      valida_existencia: "S",
    };
    setIsDoingSomething(true);
    const response = await getCristalBlock(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      if (parOjo === "OI") {
        setIniciarAnteojoArregloData({
          ...iniciarAnteojoArregloData,
          oiIdBlockCristal: response.data.data[0].id,
          oiCodigoBlockCristal: response.data.data[0].codigo,
          oiDescripcionBlockCristal:
            response.data.data[0].descripcion +
            " - " +
            response.data.data[0].modelo +
            " - OJO: " +
            response.data.data[0].ojo,
        });
        setAgregarOiBlockCristalDisabled(true);
        setQuitarOiBlockCristalDisabled(false);
      } else {
        setIniciarAnteojoArregloData({
          ...iniciarAnteojoArregloData,
          odIdBlockCristal: response.data.data[0].id,
          odCodigoBlockCristal: response.data.data[0].codigo,
          odDescripcionBlockCristal:
            response.data.data[0].descripcion +
            " - " +
            response.data.data[0].modelo +
            " - OJO: " +
            response.data.data[0].ojo,
        });
        setAgregarOdBlockCristalDisabled(true);
        setQuitarOdBlockCristalDisabled(false);
      }
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
      if (parOjo === "OI") {
        handleLimpiarBlockCristalOI();
      } else {
        handleLimpiarBlockCristalOD();
      }
    }
  };
  //
  // ################################################################################
  //
  const handleLimpiarBlockCristalOI = () => {
    setIniciarAnteojoArregloData({
      ...iniciarAnteojoArregloData,
      oiIdBlockCristal: "",
      oiCodigoBlockCristal: "",
      oiDescripcionBlockCristal: "",
    });
    setAgregarOiBlockCristalDisabled(false);
    setQuitarOiBlockCristalDisabled(true);
  };
  //
  // ################################################################################
  //
  const handleLimpiarBlockCristalOD = () => {
    setIniciarAnteojoArregloData({
      ...iniciarAnteojoArregloData,
      odIdBlockCristal: "",
      odCodigoBlockCristal: "",
      odDescripcionBlockCristal: "",
    });
    setAgregarOdBlockCristalDisabled(false);
    setQuitarOdBlockCristalDisabled(true);
  };
  //
  // ################################################################################
  //
  const agregarQuitarArmAsolNuevoAnteojo = async (parAction) => {
    if (parAction === "agregar") {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: true,
        idArticuloArmAsol: anteojo.id_articulo_arm_asol,
      });
      setAgregarArmAsolNuevoDisabled(true);
      setQuitarArmAsolNuevoDisabled(false);
    } else {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: false,
        idArticuloArmAsol: "",
      });
      setAgregarArmAsolNuevoDisabled(false);
      setQuitarArmAsolNuevoDisabled(true);
    }
  };
  //
  // ################################################################################
  //
  const agregarQuitarArmAsolNuevoArreglo = async (parAction) => {
    if (parAction === "agregar") {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: true,
        idArticuloArmAsol: arreglo.id_articulo_arm_asol,
      });
      setAgregarArmAsolNuevoDisabled(true);
      setQuitarArmAsolNuevoDisabled(false);
    } else {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: false,
        idArticuloArmAsol: "",
      });
      setAgregarArmAsolNuevoDisabled(false);
      setQuitarArmAsolNuevoDisabled(true);
    }
  };
  //
  // ################################################################################
  //
  const agregarQuitarMonturaClienteAnteojo = async (parAction) => {
    if (parAction === "agregar") {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: true,
      });
      setAgregarMonturaClienteDisabled(true);
      setQuitarMonturaClienteDisabled(false);
    } else {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: false,
      });
      setAgregarMonturaClienteDisabled(false);
      setQuitarMonturaClienteDisabled(true);
    }
  };
  //
  // ################################################################################
  //
  const agregarQuitarMonturaClienteArreglo = async (parAction) => {
    if (parAction === "agregar") {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: true,
      });
      setAgregarMonturaClienteDisabled(true);
      setQuitarMonturaClienteDisabled(false);
    } else {
      setIniciarAnteojoArregloData({
        ...iniciarAnteojoArregloData,
        monturaNuevoClienteAgregadoBandeja: false,
      });
      setAgregarMonturaClienteDisabled(false);
      setQuitarMonturaClienteDisabled(true);
    }
  };
  //
  // ################################################################################
  //
  const iniciarAnteojoArreglo = async () => {
    setIniciarAnteojoArregloData({
      ...iniciarAnteojoArregloData,
      bandeja: iniciarAnteojoArregloData.bandeja.trim().toUpperCase(),
      observaciones: iniciarAnteojoArregloData.observaciones.trim().toUpperCase(),
    });

    if (!iniciarAnteojoArregloData.bandeja) {
      // si no se ha indicado la bandeja

      setMessage({
        severity: "error",
        messageText:
          "Debes ingresar el número de la bandeja para el " +
          iniciarAnteojoArregloData.anteojoArreglo,
      });
      setShowMessage(true);
      return;
    }

    if (!isNumeric(iniciarAnteojoArregloData.bandeja)) {
      // si no se ha indicado la bandeja

      setMessage({
        severity: "error",
        messageText: "No es correcto el número de bandeja ingresado",
      });
      setShowMessage(true);
      return;
    }

    if (iniciarAnteojoArregloData.anteojoArreglo === "anteojo") {
      // si es un anteojo

      if (iniciarAnteojoArregloData.monturaNuevoCliente === "nuevo") {
        // si es con arm/asol nuevo

        if (!iniciarAnteojoArregloData.monturaNuevoClienteAgregadoBandeja) {
          // si el usuario no agrego el arm/asol a la bandeja

          setMessage({
            severity: "error",
            messageText: "Debes agregar la montura nueva a la bandeja",
          });
          setShowMessage(true);
          return;
        }
      } else {
        // si es con montura del cliente

        if (iniciarAnteojoArregloData.clienteDejaSuAnteojo) {
          // si el cliente deja su anteojo

          if (!iniciarAnteojoArregloData.monturaNuevoClienteAgregadoBandeja) {
            // si el usuario no agrego la montura del cliente a la bandeja

            setMessage({
              severity: "error",
              messageText: "Debes agregar la montura del Cliente a la bandeja",
            });
            setShowMessage(true);
            return;
          }
        }
      }

      if (iniciarAnteojoArregloData.odTieneBlockCristal) {
        // si el anteojo tiene cristal/block para ojo derecho

        if (!iniciarAnteojoArregloData.odIdBlockCristal) {
          // si el usuario no selecciono el cristal/block para ojo derecho

          setMessage({
            severity: "error",
            messageText: "Debes seleccionar el cristal/block para el ojo derecho",
          });
          setShowMessage(true);
          return;
        }
      }

      if (iniciarAnteojoArregloData.oiTieneBlockCristal) {
        // si el anteojo tiene cristal/block para ojo izquierdo

        if (!iniciarAnteojoArregloData.oiIdBlockCristal) {
          // si el usuario no selecciono el cristal/block para ojo izquierdo

          setMessage({
            severity: "error",
            messageText: "Debes seleccionar el cristal/block para el ojo izquierdo",
          });
          setShowMessage(true);
          return;
        }
      }
    } else {
      // si es un arreglo

      if (iniciarAnteojoArregloData.paseDeCristales) {
        // si es un pase de cristales

        if (iniciarAnteojoArregloData.monturaNuevoCliente === "nuevo") {
          // si es con arm/asol nuevo

          if (!iniciarAnteojoArregloData.monturaNuevoClienteAgregadoBandeja) {
            // si el usuario no agrego el arm/asol a la bandeja

            setMessage({
              severity: "error",
              messageText: "Debes agregar la montura nueva a la bandeja",
            });
            setShowMessage(true);
            return;
          }
        } else {
          // si es con montura del cliente

          if (!iniciarAnteojoArregloData.monturaNuevoClienteAgregadoBandeja) {
            // si el usuario no agrego la montura del cliente a la bandeja

            setMessage({
              severity: "error",
              messageText: "Debes agregar la montura del Cliente a la bandeja",
            });
            setShowMessage(true);
            return;
          }
        }
      }
    }

    if (!iniciarAnteojoArregloData.idAreaDestino) {
      // si no se ha indicado el area de destino

      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el área de destino",
      });
      setShowMessage(true);
      return;
    }

    let _iniciaProduccionObject = {
      anteojo_arreglo: iniciarAnteojoArregloData.anteojoArreglo,
      id_gc_anteojo_arreglo: idGcAnteojoArreglo,
      bandeja: +iniciarAnteojoArregloData.bandeja,
      montura_nuevo_cliente: iniciarAnteojoArregloData.monturaNuevoCliente ?? "",
      id_articulo_arm_asol: iniciarAnteojoArregloData.idArticuloArmAsol,
      cliente_deja_su_anteojo: iniciarAnteojoArregloData.clienteDejaSuAnteojo ? true : false,
      tiene_block_cristal_od: iniciarAnteojoArregloData.odTieneBlockCristal,
      id_articulo_block_cristal_od: iniciarAnteojoArregloData.odIdBlockCristal,
      tiene_block_cristal_oi: iniciarAnteojoArregloData.oiTieneBlockCristal,
      id_articulo_block_cristal_oi: iniciarAnteojoArregloData.oiIdBlockCristal,
      pase_de_cristales: iniciarAnteojoArregloData.paseDeCristales,
      id_area_destino: iniciarAnteojoArregloData.idAreaDestino,
      observaciones: iniciarAnteojoArregloData.observaciones,
    };
    save(_iniciaProduccionObject);
  };
  //
  // ################################################################################
  //
  const save = async (parIniciaProduccion) => {
    setIsDoingSomething(true);
    const response = await iniciaProduccion(parIniciaProduccion);
    setIsDoingSomething(false);

    if (response.ok) {
      onIniciarAnteojoArreglo();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const onDatosAnteojoArreglo = (parDatosAnteojoArreglo) => { };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          INICIAR {anteojoArreglo.toUpperCase()} {codigoAnteojoArreglo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {idGestionAtencion && (
            <DatosGestionAtencionCliente
              idGestionAtencion={idGestionAtencion}
              onDatosAnteojoArreglo={onDatosAnteojoArreglo}
            />
          )}

          <Box
            sx={{
              border: "2px solid steelblue",
              borderRadius: "5px",
              p: 2,
            }}
          >
            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Asignar bandeja
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={2} lg={2}>
                <TextField
                  id="bandeja"
                  label="Código de bandeja"
                  size="small"
                  sx={{ width: "100%" }}
                  type="number"
                  inputProps={{
                    autoComplete: "off",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    style: { textAlign: "left" },
                  }}
                  name="bandeja"
                  value={iniciarAnteojoArregloData.bandeja}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            {esAnteojo && (
              <>
                <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Armazón / Anteojo de Sol
                      </Typography>
                    </Grid>
                  </Grid>

                  {anteojo.montura_nuevo_cliente === "nuevo" && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          id="armazonAsol"
                          label="Código - Descripción - Marca - Modelo"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                          name="armazonAsol"
                          value={anteojo.armazonAsol}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Button
                          sx={{ mt: 1, mr: 1, backgroundColor: "warning" }}
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => {
                            agregarQuitarArmAsolNuevoAnteojo("agregar");
                          }}
                          disabled={agregarArmAsolNuevoDisabled}
                        >
                          Agregar a bandeja
                        </Button>

                        <Button
                          sx={{ mt: 1, mr: 1 }}
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            agregarQuitarArmAsolNuevoAnteojo("quitar");
                          }}
                          disabled={quitarArmAsolNuevoDisabled}
                        >
                          Quitar de bandeja
                        </Button>
                      </Grid>
                    </>
                  )}

                  {anteojo.montura_nuevo_cliente === "cliente" &&
                    anteojo.cliente_deja_su_anteojo && (
                      <>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            id="cliente_deja_su_anteojo"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                            name="cliente_deja_su_anteojo"
                            value={anteojo.clienteDejaSuAnteojoDetalle}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Button
                            sx={{ mt: 1, mr: 1, backgroundColor: "warning" }}
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={() => {
                              agregarQuitarMonturaClienteAnteojo("agregar");
                            }}
                            disabled={agregarMonturaClienteDisabled}
                          >
                            Agregar a bandeja
                          </Button>

                          <Button
                            sx={{ mt: 1, mr: 1 }}
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              agregarQuitarMonturaClienteAnteojo("quitar");
                            }}
                            disabled={quitarMonturaClienteDisabled}
                          >
                            Quitar de bandeja
                          </Button>
                        </Grid>
                      </>
                    )}

                  {anteojo.montura_nuevo_cliente === "cliente" &&
                    !anteojo.cliente_deja_su_anteojo && (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Typography
                            variant="overline"
                            gutterBottom
                            sx={{ fontWeight: "bold", color: "brown" }}
                          >
                            EL CLIENTE NO DEJO SU ANTEOJO
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            id="estado_montura"
                            label="Estado de la montura"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                            name="estado_montura"
                            value={anteojo.estado_montura}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={1} lg={1}>
                          <TextField
                            id="medida_horizontal"
                            label="Medida horizontal"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_horizontal"
                            value={anteojo.medida_horizontal}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={1} lg={1}>
                          <TextField
                            id="medida_vertical"
                            label="Medida vertical"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_vertical"
                            value={anteojo.medida_vertical}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={1} lg={1}>
                          <TextField
                            id="medida_diagonal"
                            label="Medida diagonal"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_diagonal"
                            value={anteojo.medida_diagonal}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={1} lg={1}>
                          <TextField
                            id="medida_puente"
                            label="Medida puente"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_puente"
                            value={anteojo.medida_puente}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={1} lg={1}>
                          <TextField
                            id="medida_mayor"
                            label="Medida mayor"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_mayor"
                            value={anteojo.medida_mayor}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <TextField
                            id="perfil"
                            label="Perfil"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="perfil"
                            value={anteojo.perfil}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <TextField
                            id="caracteristica"
                            label="caracteristica"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="caracteristica"
                            value={anteojo.caracteristica}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={1} lg={1}>
                          <TextField
                            id="base"
                            label="base"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="base"
                            value={anteojo.base}
                          />
                        </Grid>
                      </Grid>
                    )}
                </Box>

                <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Cristales
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="tipoAnteojo"
                        label="Tipo de Anteojo"
                        size="small"
                        sx={{ width: "100%", mb: 1 }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="tipoDeAnteojo"
                        value={anteojo.tipoDeAnteojo ? anteojo.tipoDeAnteojo : ""}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        id="cristalOD"
                        label="Cristal para ojo derecho"
                        size="small"
                        sx={{ width: "100%", mb: 1 }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOD"
                        value={anteojo.cristalOD ? anteojo.cristalOD : ""}
                        variant="outlined"
                        multiline
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        id="cristalOI"
                        label="Cristal para ojo izquierdo"
                        size="small"
                        sx={{ width: "100%", mb: 1 }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOI"
                        value={anteojo.cristalOI ? anteojo.cristalOI : ""}
                        variant="outlined"
                        multiline
                      />
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item sm={2}></Grid>

                      <Grid item sm={2}></Grid>

                      <Grid item sm={2}>
                        <Typography component="div" gutterBottom align="left">
                          Distancia pupilar
                        </Typography>
                      </Grid>

                      <Grid item sm={2}>
                        <Typography component="div" gutterBottom align="left">
                          Altura pupilar
                        </Typography>
                      </Grid>

                      <Grid item sm={2}>
                        <Typography component="div" gutterBottom align="left">
                          Altura párpado inferior
                        </Typography>
                      </Grid>

                      <Grid item sm={2}></Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item sm={2}></Grid>

                      <Grid item sm={2}>
                        <Typography
                          component="div"
                          gutterBottom
                          align="center"
                          sx={{ fontWeight: "bold" }}
                        >
                          Ojo derecho
                        </Typography>
                      </Grid>

                      <Grid item sm={2}>
                        <TextField
                          id="distancia_pupilar_od"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="distancia_pupilar_od"
                          value={anteojo.distancia_pupilar_od}
                        />
                      </Grid>

                      <Grid item sm={2}>
                        <TextField
                          id="altura_pupilar_od"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_pupilar_od"
                          value={anteojo.altura_pupilar_od}
                        />
                      </Grid>

                      <Grid item sm={2}>
                        <TextField
                          id="altura_parpado_inferior_od"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_parpado_inferior_od"
                          value={anteojo.altura_parpado_inferior_od}
                        />
                      </Grid>

                      <Grid item sm={2}></Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item sm={2}></Grid>

                      <Grid item sm={2}>
                        <Typography
                          component="div"
                          gutterBottom
                          align="center"
                          sx={{ fontWeight: "bold" }}
                        >
                          Ojo izquierdo
                        </Typography>
                      </Grid>

                      <Grid item sm={2}>
                        <TextField
                          id="distancia_pupilar_oi"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="distancia_pupilar_oi"
                          value={anteojo.distancia_pupilar_oi}
                        />
                      </Grid>

                      <Grid item sm={2}>
                        <TextField
                          id="altura_pupilar_oi"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_pupilar_oi"
                          value={anteojo.altura_pupilar_oi}
                        />
                      </Grid>

                      <Grid item sm={2}>
                        <TextField
                          id="altura_parpado_inferior_oi"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_parpado_inferior_oi"
                          value={anteojo.altura_parpado_inferior_oi}
                        />
                      </Grid>

                      <Grid item sm={2}></Grid>
                    </Grid>
                  </Grid>

                  <Box sx={{ p: 1, mt: 1 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={6}>
                        <Typography
                          component="div"
                          gutterBottom
                          align="left"
                          sx={{ fontWeight: "bold", mb: 2 }}
                        >
                          Cristal/Block para ojo Derecho
                        </Typography>

                        <TextField
                          sx={{ mb: 1, mr: 1 }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="codigo-cristal-block-od"
                          label="Código de Cristal/Block"
                          variant="outlined"
                          size="small"
                          name="odCodigoBlockCristal"
                          value={iniciarAnteojoArregloData.odCodigoBlockCristal}
                          onChange={handleChange}
                          disabled={
                            !iniciarAnteojoArregloData.odTieneBlockCristal ||
                            agregarOdBlockCristalDisabled
                          }
                        />
                        <Button
                          sx={{ mr: 1 }}
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={handleBuscarBlockCristalOD}
                          disabled={
                            !iniciarAnteojoArregloData.odTieneBlockCristal ||
                            agregarOdBlockCristalDisabled
                          }
                        >
                          Agregar a bandeja
                        </Button>

                        <Button
                          sx={{ mr: 1 }}
                          variant="outlined"
                          size="small"
                          onClick={handleLimpiarBlockCristalOD}
                          disabled={
                            !iniciarAnteojoArregloData.odTieneBlockCristal ||
                            quitarOdBlockCristalDisabled
                          }
                        >
                          Quitar de bandeja
                        </Button>

                        <TextField
                          sx={{ mb: 1, width: "100%" }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="descripcion-cristal-block-od"
                          label="Descripción de Cristal/Block"
                          variant="outlined"
                          size="small"
                          name="odDescripcionBlockCristal"
                          value={iniciarAnteojoArregloData.odDescripcionBlockCristal}
                          disabled
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography
                          component="div"
                          gutterBottom
                          align="left"
                          sx={{ fontWeight: "bold", mb: 2 }}
                        >
                          Cristal/Block para ojo Izquierdo
                        </Typography>

                        <TextField
                          sx={{ mb: 1, mr: 1 }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="codigo-cristal-block-oi"
                          label="Código de Cristal/Block"
                          variant="outlined"
                          size="small"
                          name="oiCodigoBlockCristal"
                          value={iniciarAnteojoArregloData.oiCodigoBlockCristal}
                          onChange={handleChange}
                          disabled={
                            !iniciarAnteojoArregloData.oiTieneBlockCristal ||
                            agregarOiBlockCristalDisabled
                          }
                        />

                        <Button
                          sx={{ mr: 1 }}
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={handleBuscarBlockCristalOI}
                          disabled={
                            !iniciarAnteojoArregloData.oiTieneBlockCristal ||
                            agregarOiBlockCristalDisabled
                          }
                        >
                          Agregar a bandeja
                        </Button>

                        <Button
                          sx={{ mr: 1 }}
                          variant="outlined"
                          size="small"
                          onClick={handleLimpiarBlockCristalOI}
                          disabled={
                            !iniciarAnteojoArregloData.oiTieneBlockCristal ||
                            quitarOiBlockCristalDisabled
                          }
                        >
                          Quitar de bandeja
                        </Button>

                        <TextField
                          sx={{ mb: 1, width: "100%" }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="descripcion-cristal-block-oi"
                          label="Descripción de Cristal/Block"
                          variant="outlined"
                          size="small"
                          name="oiDescripcionBlockCristal"
                          value={iniciarAnteojoArregloData.oiDescripcionBlockCristal}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>

                {anteojoTratamientoRows.length > 0 && (
                  <Accordion
                    sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      Tratamientos
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                        <DataGrid
                          rows={anteojoTratamientoRows}
                          columns={tableColumnsTratamiento}
                          {...tableOptions}
                        />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}

                {anteojo.observaciones_gc_anteojo && (
                  <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Notas y observaciones de la Gestión de Atención
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="observaciones_gc_anteojo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="observaciones_gc_anteojo"
                        value={anteojo.observaciones_gc_anteojo}
                        multiline
                      />
                    </Grid>
                  </Box>
                )}
              </>
            )}

            {esArreglo && (
              <>
                {arreglo.pase_de_cristales && (
                  <Typography variant="subtitle1" gutterBottom>
                    PASE DE CRISTALES
                  </Typography>
                )}
                <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Anteojo y Cristales del Cliente
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="descripcion_anteojo_cristales"
                        label="Anteojo y Cristales del Cliente"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="descripcion_anteojo_cristales"
                        value={
                          arreglo.descripcion_anteojo_cristales
                            ? arreglo.descripcion_anteojo_cristales
                            : ""
                        }
                        variant="outlined"
                        multiline
                      />
                    </Grid>
                  </Grid>
                </Box>

                {arreglo.pase_de_cristales && arreglo.montura_nuevo_cliente === "nuevo" && (
                  <>
                    <Box
                      sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}
                    >
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Armazón / Anteojo de Sol
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          id="armazonAsol"
                          label="Código - Descripción - Marca - Modelo"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                          name="armazonAsol"
                          value={arreglo.armazonAsol}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Button
                          sx={{ mt: 1, mr: 1, backgroundColor: "warning" }}
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => {
                            agregarQuitarArmAsolNuevoArreglo("agregar");
                          }}
                          disabled={agregarArmAsolNuevoDisabled}
                        >
                          Agregar a bandeja
                        </Button>

                        <Button
                          sx={{ mt: 1, mr: 1 }}
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            agregarQuitarArmAsolNuevoArreglo("quitar");
                          }}
                          disabled={quitarArmAsolNuevoDisabled}
                        >
                          Quitar de bandeja
                        </Button>
                      </Grid>
                    </Box>
                  </>
                )}

                {arreglo.pase_de_cristales && arreglo.montura_nuevo_cliente === "cliente" && (
                  <>
                    <Box
                      sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}
                    >
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Armazón / Anteojo de Sol
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          id="estado_montura"
                          label="Estado de la montura"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                          name="estado_montura"
                          value={arreglo.estado_montura}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Button
                          sx={{ mt: 1, mr: 1, backgroundColor: "warning" }}
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => {
                            agregarQuitarMonturaClienteArreglo("agregar");
                          }}
                          disabled={agregarMonturaClienteDisabled}
                        >
                          Agregar a bandeja
                        </Button>

                        <Button
                          sx={{ mt: 1, mr: 1 }}
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            agregarQuitarMonturaClienteArreglo("quitar");
                          }}
                          disabled={quitarMonturaClienteDisabled}
                        >
                          Quitar de bandeja
                        </Button>
                      </Grid>
                    </Box>
                  </>
                )}

                {arregloServicioRows.length > 0 && (
                  <Accordion
                    sx={{
                      border: "1px solid LightGrey",
                      mb: 1,
                      p: 0,
                      borderRadius: "5px",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      Servicios
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                        <DataGrid
                          rows={arregloServicioRows}
                          columns={tableColumnsServicio}
                          {...tableOptions}
                        />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}

                {arregloTratamientoRows.length > 0 && (
                  <Accordion
                    sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      Tratamientos
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                        <DataGrid
                          rows={arregloTratamientoRows}
                          columns={tableColumnsTratamiento}
                          {...tableOptions}
                        />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}

                {arregloFornituraRows.length > 0 && (
                  <Accordion
                    sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      Fornituras
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px" }}>
                        <DataGrid
                          rows={arregloFornituraRows}
                          columns={tableColumnsFornitura}
                          {...tableOptions}
                        />
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}

                {arreglo.observaciones_gc_arreglo && (
                  <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Notas y observaciones de la Gestión de Atención
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="observaciones_gc_arreglo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="observaciones_gc_arreglo"
                        value={arreglo.observaciones_gc_arreglo}
                        multiline
                      />
                    </Grid>
                  </Box>
                )}
              </>
            )}

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Área de Destino
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      id="id-area-destino"
                      size="small"
                      width="50%"
                      value={
                        valueACArea && valueACArea.id
                          ? valueACArea
                          : null
                      }
                      onChange={(event, newValue) => {
                        setvalueACArea(newValue);
                        setIniciarAnteojoArregloData({
                          ...iniciarAnteojoArregloData,
                          idAreaDestino: newValue ? newValue.id : "",
                        });
                      }}
                      inputValue={inputvalueACArea}
                      onInputChange={(event, newInputValue) => {
                        setInputvalueACArea(newInputValue);
                      }}
                      options={areas}
                      getOptionLabel={(option) => option.descripcion || ""}
                      renderInput={(params) => <TextField {...params} label="Área de Destino" />}
                      isOptionEqualToValue={(option, value) => {
                        if (!value || !value.id) return false;
                        return option.id === value.id;
                      }}
                    // disableClearable={true}
                    />
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1, mb: 1 }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Notas y observaciones
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <TextField
                      id="observaciones"
                      label="Notas y observaciones"
                      size="small"
                      sx={{ width: "100%" }}
                      inputProps={{ autoComplete: "off", style: { textAlign: "left" } }}
                      name="observaciones"
                      value={iniciarAnteojoArregloData.observaciones}
                      variant="outlined"
                      onChange={handleChange}
                    />
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={() => {
                iniciarAnteojoArreglo();
              }}
              startIcon={<PlayCircleOutlineOutlinedIcon />}
            // disabled={isDoingSomething}
            >
              Iniciar producción
            </Button>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={handleCloseDialog}
            // disabled={isDoingSomething}
            >
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default IniciarAnteojoArregloDialog;
